export default __webpack_public_path__ + "static/media/selena_yao.b7fbcb7f.jpg";